import { render } from "./RedSpinner.vue?vue&type=template&id=3fc20df1&scoped=true"
import script from "./RedSpinner.vue?vue&type=script&lang=js"
export * from "./RedSpinner.vue?vue&type=script&lang=js"

import "./RedSpinner.vue?vue&type=style&index=0&id=3fc20df1&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc20df1"]])

export default __exports__